import React, { SVGAttributes } from 'react';

export default function ClockIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 28 28" fill="none" {...props}>
      <path d="M20.4443 9.00015L15.2297 14.629C14.9921 14.8665 14.6699 15 14.334 15H9C8.44771 15 8 14.5523 8 14C8 13.4477 8.44771 13 9 13H14.0302L19.0301 7.58594C19.4206 7.19542 20.0538 7.19542 20.4443 7.58594C20.8349 7.97647 20.8349 8.60963 20.4443 9.00015Z" fill="currentColor" />
      <path d="M14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28ZM14 26C20.6274 26 26 20.6274 26 14C26 7.37258 20.6274 2 14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26Z" fill="currentColor" />
    </svg>
  );
}
